import { paths } from 'src/routes/paths';

/** Ledger page URL with packetId filter (user section top + platform section bottom). */
export function socialTradingLedgerEntriesByPacketPath(packetId: string): string {
  const id = String(packetId || '').trim();
  if (!id) return paths.socialTrading.redpacketLedgerEntries.root;
  const filter = encodeURIComponent(JSON.stringify({ packetId: id }));
  const displayedFilters = encodeURIComponent(JSON.stringify({ packetId: true }));
  return `${paths.socialTrading.redpacketLedgerEntries.root}?filter=${filter}&displayedFilters=${displayedFilters}`;
}

/** @deprecated Use socialTradingLedgerEntriesByPacketPath — pages are merged. */
export function socialTradingPlatformLedgerByPacketPath(packetId: string): string {
  return socialTradingLedgerEntriesByPacketPath(packetId);
}
